import React from "react";
import SideBar from "../../components/Sidebar";
import PopularServices from "./PopularServices";
import MobileApp from "../../components/MobileApp";

const Home = () => {
  return (
    <div>
      <div className="container-fluid mt-3">
        <div className="row">
          {/* Sidebar */}

          <SideBar />

          {/* Main Content */}
          <div className="col-md-6 mb-3">
            {/* Popular Services */}
            <div className="card mb-4 shadow-sm">
              <div className="card-body">
                <h5 className="card-title">Popular Services</h5>
                <div className="row text-center">
                  <PopularServices />
                </div>
              </div>
            </div>

            {/* Gift Cards */}
            {/* <div className="card shadow-sm">
              <div className="card-body">
                <h5 className="card-title">Top Gift Card</h5>
                <div className="row">
                  {[
                    { name: "Vijay Sales", discount: "2.00%" },
                    { name: "Croma", discount: "2.60%" },
                    { name: "@ Home", discount: "7.75%" },
                    { name: "Skullcandy", discount: "8%" },
                  ].map((gift, index) => (
                    <div className="col-6 col-lg-3 mb-3" key={index}>
                      <div className="border p-2 text-center rounded bg-light">
                        <div className="mb-2 fw-bold">{gift.name}</div>
                        <span className="badge bg-success">
                          {gift.discount} OFF
                        </span>
                      </div>
                    </div>
                  ))}
                  <div className="col-12 text-end">
                    <button className="btn btn-outline-primary btn-sm">
                      See All
                    </button>
                  </div>
                </div>
              </div>
            </div> */}
          </div>

          {/* News Section */}
          <div className="col-md-3">
            <div className="card shadow-sm">
              <div className="card-body">
                {/* Bootstrap Carousel */}
                <div
                  id="newsCarousel"
                  className="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div className="carousel-inner">
                    {/* Replace with your image URLs */}
                    <div className="carousel-item active">
                      <a href="/recharge-and-bill-payment">
                        <img
                          src="/assets/images/recharge-banner2.png"
                          className="d-block w-100"
                          alt="News 1"
                          style={{ height: "250px", objectFit: "cover" }}
                        />
                      </a>
                    </div>
                    {/* <div className="carousel-item">
                      <img
                        src="/assets/images/rentpay-banner3.png"
                        className="d-block w-100"
                        alt="News 2"
                        style={{ height: "250px", objectFit: "cover" }}
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src="/assets/images/rentpay-banner.png"
                        className="d-block w-100"
                        alt="News 3"
                        style={{ height: "250px", objectFit: "cover" }}
                      />
                    </div> */}
                  </div>

                  {/* Optional Controls */}
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#newsCarousel"
                    data-bs-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#newsCarousel"
                    data-bs-slide="next"
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
            </div>

            <div className="card shadow-sm mt-4">
              <div className="card-body p-0" style={{ height: "300px" }}>
                <a href="/mantra-device" target="_blank">
                  <img
                    src="/assets/images/mantra-banner.png"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    alt="Gamezop Banner"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MobileApp />
    </div>
  );
};
export default Home;
